import { render, staticRenderFns } from "./DoughnutChartWithoutFiltersSection.vue?vue&type=template&id=50387e81"
import script from "./DoughnutChartWithoutFiltersSection.vue?vue&type=script&lang=js"
export * from "./DoughnutChartWithoutFiltersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports